import { IconButton, Tooltip } from "@mui/material"
import SendIcon from "@mui/icons-material/Send";

interface SendProps {
    handleStartChat: () => void
    isSendButtonDisabled: boolean
}

const Send: React.FC<SendProps> = ({ handleStartChat, isSendButtonDisabled }) => {
    return (
        <Tooltip title="Send message">
            <IconButton onClick={handleStartChat} disabled={isSendButtonDisabled}>
                <SendIcon />
            </IconButton>
        </Tooltip>
    )
}
export default Send;